// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__TQmnr","col":"styles_col__2bekn"};